/* eslint-disable max-lines */
import React, { useEffect, useRef } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import ReportList from '../../components/Radiology/ReportList';
import { useDispatch, useSelector } from 'react-redux';
import { getAllTypes, resetSelectReport } from '../../redux/Reports/ReportsAction';
import useCheckMobileScreen from '../../hooks/useWidth';
import { PropTypes } from 'prop-types';
import RadiologyDetail from '../../components/Radiology/RadiologyDetail';
import { Route, Switch, useHistory, useParams, useRouteMatch, useLocation } from 'react-router';
import RadiologyForm from '../../components/Radiology/RadiologyForm';
import useCheckAccess from '../../hooks/useCheckAccess';
const styles = makeStyles({
    container: {
        margin: '-24px'
    },
    gridContainer: {
        height: '100%',
        // overflow: 'auto',
        width: '100%'
    },
    listContainer: {
        overflow: 'auto',
        direction: 'rtl',
        padding: '24px',
        height: 'calc(100vh - 100px)',
        position: 'sticky',
        top: 0
    },
    detailContainer: {
        padding: '24px',
        '& > div': {
            height: 'unset'
        }
    }
});
const Radiology = () => {
    const classes = styles();
    const isMobile = useCheckMobileScreen();
    const { path } = useRouteMatch();
    const params = useParams();
    const { pathname } = useLocation();
    const history = useHistory();
    const url = `/${params.clinicId}/patient/${params.id}/radiology`;
    const reportId = useSelector((state) => state?.reports?.form?.reportId);
    const ref = useRef(true);
    const { notEditClinical } = useCheckAccess();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAllTypes());
        return () => {
            dispatch({ type: 'CLOSE_MODAL' });
        };
    }, []);
    useEffect(() => {
        if (!isMobile || !reportId) {
            history.replace(url);
        }
    }, [isMobile, reportId]);

    useEffect(() => {
        if (ref.current) {
            ref.current = false;
        } else {
            if (pathname === url) dispatch(resetSelectReport());
        }
    }, [pathname, url, ref.current, isMobile]);

    return (
        <>
            {isMobile ? (
                <>
                    <Switch>
                        <Route exact path={path} component={ReportList} />
                        <Route exact path={`${path}/detail`} component={RadiologyDetail} />
                        {!notEditClinical && (
                            <Route exact path={`${path}/form`} component={RadiologyForm} />
                        )}
                    </Switch>
                </>
            ) : (
                <div className={classes.container}>
                    <Grid container className={classes.gridContainer}>
                        <Grid item xs={12} md={3} className={classes.listContainer}>
                            <ReportList />
                        </Grid>
                        <Grid item xs={12} md={9} className={classes.detailContainer}>
                            <RadiologyDetail />
                        </Grid>
                    </Grid>
                </div>
            )}
        </>
    );
};
Radiology.propTypes = {
    location: PropTypes.object
};

export default Radiology;
